import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import { getStationHistoricalById, getStationHistoricalByIdAndStartTime } from '../store/reducers/fmAPI.js';
import { ReferenceArea } from 'recharts';

import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';

import loadable from '@loadable/component';

import { ListGroup } from 'react-bootstrap';

import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';

import { Water, Check2Circle, DropletFill, BoxArrowLeft, ArrowUpRightCircleFill, ArrowRightCircleFill, ArrowDownRightCircleFill } from 'react-bootstrap-icons';
import Badge from 'react-bootstrap/Badge';

import CentralLink from '../components/CentralLink.js';
import StationLinker from '../components/StationLinker.js';

import StationNameRenderer from '../components/StationNameRenderer.js';
import WaterLevelGauge from '../components/WaterLevelGauge.js';
import WaterLevelLineChart from '../components/WaterLevelLineChart.js';
import MapViewHeaderComponent from '../components/MapViewHeaderComponent.js'
import FloodAlertSummaryComponent from '../components/FloodAlertSummaryComponent.js';
import NearByStationsComponent from '../components/NearByStationsComponent.js';
import FMCoverageAreas from '../components/FMCoverageAreas.js';
import Loading from '../components/Loading.js';
import GoverningBodyName from '../components/GoverningBodyName.js';
import StationFloodEventLinker from '../components/StationFloodEventLinker.js'
import FBMessengerContactButton from '../components/FBMessengerContactButton.js';

import CommonHeaders from '../components/helmet-headers/CommonHeaders.js';
import Breadcrumbs, { CRUMBS } from '../components/helmet-headers/Breadcrumbs.js';

const AdComponent = loadable(() => import('../components/AdComponent.js'));
const FloodEventExplainer = loadable(() => import('../components/FloodEventExplainer.js'));

function StationHistoricalFloodView() {
	const params = useParams();
	const dispatch = useDispatch();
	const location = useLocation();
	const { stationsHistorical, stationsHistoricalData } = useSelector(state => state.fmAPI);
	const [dateSelectorIndex, setDateSelectorIndex] = useState(0);
	const [chartOrTableView, setChartOrTableView] = useState('chart');
	const [apiError, setApiError] = useState(false);
	const [waitingOnApi, setWaitingOnApi] = useState(false);


	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location]);

	useEffect(() => {
		setWaitingOnApi(true);
		if(!stationsHistoricalData || !stationsHistoricalData[params.stationId] || !stationsHistoricalData[params.stationId][params.dateTime]) {
			dispatch(getStationHistoricalByIdAndStartTime(params.stationId, params.dateTime, null, function(err) {
				setApiError(!!err);
				setWaitingOnApi(false);
			}))
		}
	}, [dispatch, params.stationId]);

	if(stationsHistorical && stationsHistorical[params.stationId]) {
		let station = stationsHistorical[params.stationId];
		let historicalData = null;
		if(stationsHistoricalData[params.stationId] && stationsHistoricalData[params.stationId][params.dateTime]) {
			historicalData = stationsHistoricalData[params.stationId][params.dateTime];
		}

		let computedStationName = station && <StationNameRenderer stationName={station.stationName} qualifierType={'Stage'} />;
		
		let riverName = station && station.riverName;
		let stationName = station && station.stationName;
		let townName = station && station.townName;

		let computedTitle = null;
		let townNameTitleSuffix = !!townName ? " in " + townName : "";
		if(stationName) {
			computedTitle = params.dateTime + ":: Historical Flood Records :: " + stationName + " station" + townNameTitleSuffix;
			if(riverName) {
				computedTitle = params.dateTime + " :: Historical Flood :: " + riverName + " at the " + stationName + " station" + townNameTitleSuffix;
			}
		} else if(riverName) {
			computedTitle = params.dateTime + " :: Historical Flood Records :: " + riverName + townNameTitleSuffix;
		}

		const previousDayChart = function() {
			if(dateSelectorIndex > 0) {
				setDateSelectorIndex(dateSelectorIndex-1);
			}
		};

		const nextDayChart = function() {
			setDateSelectorIndex(dateSelectorIndex+1);
		}

		let historicalDataLimitedTimeSeries = null;

		if(historicalData) {
			historicalDataLimitedTimeSeries = historicalData.timeSeries.filter(function(item) {
				return item.entryFilterBy == historicalData.event.entryFilterBys[dateSelectorIndex];
			});
		}

		let recordExists = false;
		try {
			if(station.floodEvents && Object.keys(station.floodEvents).length > 0) {
				for(let year of Object.keys(station.floodEvents)) {
					for(let record of station.floodEvents[year]) {
						if(record.startTimestampFormatted == params.dateTime) {
							console.log("XXXXXXX", record);
							recordExists = true;
							break;
						}
					}
					if(recordExists) {
						break;
					}
				}
			}
		} catch(error) {}


		let metaDescription = "Historical flood record as measured by the " + station.stationName + " station";

		if(historicalData && historicalData.event) {
			if(station.riverName) {
				metaDescription = "Historical " + station.riverName + " flood record, as measured by the " + station.stationName + " station";
			}
			if(station.placeName) {
				metaDescription = metaDescription + ", in " + station.placeName;
			}
			metaDescription = metaDescription + ".";
			
			metaDescription = metaDescription + " Flood event begins at " + historicalData.event.startTimestampFormatted + " and ends at " + historicalData.event.endTimestampFormatted + ", lasting for " + historicalData.event.startEndDiff + " " + historicalData.event.startEndDiffUnits + ".";
		}
		return <div>
			<CommonHeaders
				title={computedTitle}
				description={metaDescription}
				canonicalUrlPath={historicalData ? "/stations/"+(station.urlSlug ? station.urlSlug : station.stationId)+"/historical/flood/"+historicalData.event.startTimestampFormatted : null}
				canonicalDefaultWebsite="UK"
				ogType="event"
				lat={station.stationLat}
				lng={station.stationLng}
				townName={station.placeName}
				eventStartTime={historicalData ? historicalData.event.startTimestamp : null}
				eventEndTime={historicalData ? historicalData.event.endTimestamp : null}
			/>
			{historicalData && historicalData.event && <Breadcrumbs
				builtinCrumbs={[CRUMBS.HOME, CRUMBS.DATA_EXPLORER]}
				leafCrumbs={[{
					name: "The " + stationName + " station",
					path: "/stations/" + (station.urlSlug ? station.urlSlug : station.stationId)
				}, {
					name: "Historical Records",
					path: "/stations/" + (station.urlSlug ? station.urlSlug : station.stationId) + "/historical"
				}, {
					name: computedTitle,
					path: "/stations/" + (station.urlSlug ? station.urlSlug : station.stationId) + "/historical/flood/"+historicalData.event.startTimestampFormatted
				}]}
			/>}
			<Row className="screen-bottom-border">
				<Col xs={12} lg={1} xl={2} className="d-none d-lg-block large-screen-left">&nbsp;</Col>
				{apiError ? <Col xs={12} lg={10} xl={8}>An Error Occured</Col> : <Col xs={12} lg={10} xl={8}>
					<MapViewHeaderComponent
						key={'Stage' + params.stationId}
						lat={station.stationLat}
						lng={station.stationLng}
						label={computedStationName ? <span>{riverName ? riverName + " at " : ""}{computedStationName}</span> : "Unknown Measuring Station"}
					/>
					<Row>
						<Col xs={12}>
							<StationLinker stationId={station.stationId} isHistoricalLink urlSlug={station.urlSlug}>
								<Button variant="dark" size="sm" style={{marginBottom: "7px"}}><b><BoxArrowLeft /> Return to all flood events</b></Button>
							</StationLinker>
						</Col>
						{station.metadata.floodEventCount && station.metadata.typicalRangeHigh && <Col xs={12}>
							<FloodEventExplainer typicalRangeHigh={station.metadata.typicalRangeHigh} />
						</Col>}
						{historicalData && historicalData.event && historicalData.event.fmNotes ? <Col xs={12}>
							<Alert variant="warning"><b>Note from FloodMapper:</b> {historicalData.event.fmNotes}</Alert>
						</Col> : null}
						{(station.metadata && !station.metadata.floodEventCount) ? <Row>
							<Col xs={12}><hr /><b><i>Sorry, we don't have any historical records for this station.</i></b><hr /></Col>
						</Row> : null}
						{(station.metadata.floodEventCount && historicalData && historicalData.event) ? <Col xs={12} className="bg-secondary text-white">
							<h4 className="hX-blendin"><b>Flood Event: {historicalData.event.startTimestampFormatted}</b>-<b>{historicalData.event.endTimestampFormatted}</b></h4>
						</Col> : null}
						{(!waitingOnApi && !recordExists) ? <Col xs={12}>
							<hr />
							<h3 className="header-bold hX-blendin hX-scale-12em">We do not have a record for that requested time and date, sorry.</h3>
						</Col> : null}
						{(waitingOnApi && station.metadata.floodEventCount && !historicalData) ? <Col xs={12}><Loading /><br /><span style={{fontSize: "0.7em"}}><b>We are loading data from our archive. This may take a few seconds to load based upon:<br /><i>- the speed of your internet connection<br />- the speed of your device<br />- how much data we need to collate for you on our server.</i></b></span></Col> : null}
						{(station.metadata.floodEventCount && historicalData) ? <Col xs={12}><Row>
							<Col xs={12}>
								This flood event began on <b>{historicalData.event.startTimestampFormatted}</b>, lasted <b>{historicalData.event.startEndDiff}</b> {historicalData.event.startEndDiffUnits}, and returned below the threshold on <b>{historicalData.event.endTimestampFormatted}</b>.
							</Col>
							<Col xs={12}>
								The maximum measured height reached by this station during this flood event was <b>{historicalData.event.entryHeightMax}m</b>, achieved at <b>{historicalData.event.entryHeightMaxTimestampFormatted}</b>
							</Col>
							<Col xs={12} className="bg-secondary text-white">
								<h4 className="hX-blendin"><b>Daily charts during this event</b></h4>
							</Col>
							<Col xs={12}>
								<Row>
									<Col xs={3}><Button variant="dark" size="sm" onClick={previousDayChart} disabled={dateSelectorIndex===0}>{"<"}</Button></Col>
									<Col xs={6}>{historicalData.event.entryFilterBys[dateSelectorIndex]}</Col>
									<Col xs={3}><Button variant="dark" size="sm" onClick={nextDayChart} disabled={dateSelectorIndex===(historicalData.event.entryFilterBys.length-1)}>{">"}</Button></Col>
								</Row>
							</Col>
							<Col xs={12}>
								<Nav fill variant="tabs" defaultActiveKey="chart">
									<Nav.Item eventKey='chart' onClick={function() {
										setChartOrTableView('chart');
									}}>
										<Nav.Link className={(chartOrTableView === 'chart' ? "bg-secondary" : "bg-dark") + " text-white header-bold"} >{chartOrTableView === 'chart' ? <span><Check2Circle /> </span> : ""}Chart View</Nav.Link>
									</Nav.Item>
									<Nav.Item eventKey='data' onClick={function() {
										setChartOrTableView('data');
									}}>
										<Nav.Link className={(chartOrTableView === 'data' ? "bg-secondary" : "bg-dark") + " text-white header-bold"}>{chartOrTableView === 'data' ? <span><Check2Circle /> </span> : ""}Data View</Nav.Link>
									</Nav.Item>
							    </Nav>
							</Col>
							<Col xs={12}>
								{chartOrTableView !== 'data' ? <WaterLevelLineChart
									history={historicalDataLimitedTimeSeries}
									forecast={null}
									historicalMaximum={stationsHistorical[params.stationId].metadata.maxOnRecord}
									displayMode="quarters"
									noStepForward={true}
									key={"wlc_"+dateSelectorIndex}
								/> : <Row>
									<Col xs={12} md={2} className="d-none d-md-block">&nbsp;</Col>
									<Col xs={12} md={8}>
										{historicalDataLimitedTimeSeries.length > 0 ? <Row key={"hd_key"} style={{borderBottom: "1px solid black"}}>
												<Col xs={6} md={3}>Time/Data</Col>
												<Col xs={4} md={4} style={{textAlign: "right"}}>Reading (m)</Col>
												<Col xs={2} md={1} style={{textAlign: "left"}}>Trend</Col>
												<Col xs={6} md={3} className="d-xs-block d-md-none"></Col>
												<Col xs={4} md={4} style={{textAlign: "right"}}>Flow (m3/s)</Col>
												<Col xs={2} md={1} className="d-xs-block d-md-none"></Col>
											</Row> : <span>Error. No records to display</span>}
										{historicalDataLimitedTimeSeries.map(function(entry, entryIx) {
											const entryRounded = Math.floor(100*parseFloat(entry.entryHeight))/100;
											const flowRounded = entry.entryFlow ? Math.floor(100*parseFloat(entry.entryFlow))/100 : null;
											let entryMarker = null;
											if(entryIx > 0) {
												let prev = historicalDataLimitedTimeSeries[entryIx-1];
												let prevRounded = Math.floor(100*parseFloat(prev.entryHeight))/100;
												
												if(prevRounded.toFixed(2) < entryRounded.toFixed(2)) {
													entryMarker = <span style={{color: '#9C1300'}}><ArrowUpRightCircleFill /></span>;
												} else if(prevRounded.toFixed(2) === entryRounded.toFixed(2)) {
													entryMarker = <span style={{color: '#8C7113'}}><ArrowRightCircleFill /></span>;
												} else {
													entryMarker = <span style={{color: '#139C13'}}><ArrowDownRightCircleFill /></span>;
												}
											}
											return <Row key={"hd_"+entry.entryTimestamp}>
												<Col xs={6} md={3}>{entry.entryTimestampFormatted}</Col>
												<Col xs={4} md={4} style={{textAlign: "right"}}>{entryRounded.toFixed(2)} m</Col>
												<Col xs={2} md={1} style={{textAlign: "left"}}>{entryMarker}</Col>
												<Col xs={6} md={3} className="d-xs-block d-md-none"></Col>
												<Col xs={4} md={4} style={{textAlign: "right"}}>{flowRounded}{flowRounded ? " m3/s" : <span style={{"fontSize": "0.7em"}}><i>No flow data</i></span>}</Col>
												<Col xs={2} md={1} className="d-xs-block d-md-none"></Col>
												<Col xs={12} style={{borderBottom: "1px dotted grey"}}></Col>
											</Row>;
										})}
									</Col>
									<Col xs={12} md={2} className="d-none d-md-block">&nbsp;</Col>
								</Row>}
							</Col>
							{process.env.REACT_APP_ENABLE_GOOGLE_ADS_ON_HISTORIC === "true" ? 
								<Col xs={12} style={{marginBottom: "3px", marginTop: "3px"}}>
									<AdComponent
									  client="ca-pub-6790224688210339"
									  slot="6130981811" // Replace this with your actual data-ad-slot value
									  format="fluid"
									  layoutKey="-fb+5w+4e-db+86" // Adding a new prop for data-ad-layout-key
									  responsive={true} // Assuming you want it responsive; adjust as necessary
									/>
								</Col> : null}
							<Col xs={12} className="bg-secondary text-white">
								<h4 className="hX-blendin"><b>Full event profile</b></h4>
							</Col>
							<Col xs={12}>
								<WaterLevelLineChart
									history={historicalData.timeSeries}
									forecast={null}
									historicalMaximum={stationsHistorical[params.stationId].metadata.maxOnRecord}
									boxBoundStart={historicalDataLimitedTimeSeries && historicalDataLimitedTimeSeries.length > 0 ? historicalDataLimitedTimeSeries[0] : null}
									boxBoundEnd={historicalDataLimitedTimeSeries && historicalDataLimitedTimeSeries.length > 0 ? historicalDataLimitedTimeSeries[historicalDataLimitedTimeSeries.length-1] : null}
								>
									{/*<ReferenceArea x1={'00:00 '+historicalData.event.entryFilterBys[dateSelectorIndex]} x2={'00:00 24 Nov 2000'} stroke="blue" strokeOpacity={0.3} />*/}
								</WaterLevelLineChart>
							</Col>
						</Row></Col> : null}
					</Row>
					{station.metadata.floodEventCount ?<Row style={{paddingBottom: "4px"}}>
						<Col xs={12}>
							<hr />
							<span style={{fontSize: "0.7em"}}>
								We have collated approximately 2 billion records from across the UK agencies building up our flood event history. A lot of these are in raw format that we have had to compile and process. With so many values to iterate through, it is certain some are wrong. As such we do not check the underlying data. We do report inconsistencies back to the various agencies when we find them and ask them to fix them.<br />Values for historical flooding may have been manually input by the relevant governing body (e.g. Environment Agency). Some extreme values may also be above the maximum measurement capability of the station and could also have been edited, by the governing body, to match readings taken manually at the time.<br />
								But, if you have spotted something in our archives where you think we have made an error and the the underlying data are correct, please let us know and we can look at getting this fixed.<br />
								<FBMessengerContactButton />
							</span>
						</Col>
					</Row> : null}
				</Col>}
				<Col xs={12} lg={1} xl={2} className="d-none d-lg-block large-screen-right">&nbsp;</Col>
			</Row>
		</div>;

	} else {
		return <div><Loading /></div>;
	}


}







export default StationHistoricalFloodView;






